<template>
<Row>
  <i-col span="12">
    <Form ref="formValidate" :label-width="100">
        <FormItem label="集团名称">
           <span>{{company_name}}</span>
        </FormItem>
         <FormItem label="服务设置">
               <CheckboxGroup v-model="social">
                    <template v-for="value in servicelist" >
                    <Checkbox :label="value.code" :key="value.code" >
                             <span>{{value.name}}</span>
                    </Checkbox>
                    </template>
                </CheckboxGroup>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="company_service_set">提交</Button>
            <!-- <Button type="ghost" @click="handleReset('formValidate')" style="margin-left: 8px">Reset</Button> -->
        </FormItem>
    </Form>
     </i-col>
        <i-col span="12"></i-col>
    </Row>

</template>
<script>
import {company_service_set } from "../../api/companyapi";
import {serviceindex} from "../../api/serviceapi";
import openpage from '../../constant/openpage.js'
export default {
  data() {
    return {
      servicelist: [],
      social: [],
      company_name:""
    };
  },
  methods: {
    company_service_set() {
      let para = {
        company_id: this.company_id,
        service_code: this.social
      };
      company_service_set(para).then(res => {
        let data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          var query = { id: this.company_id };
          openpage("servicelist", query);
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    mockTableData() {
      let para = {
    
      };
      serviceindex(para).then(res => {
        var Data = res.data;
        this.servicelist = Data.data;
      });
    }
  },
  mounted() {
    if (this.$route.query) {
      this.social = JSON.parse(this.$route.query.data);
      this.company_id = this.$route.query.company_id;
      this.company_name=this.$route.query.company_name
    }
    this.mockTableData();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/company/serviceset.vue